import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FiHome, FiBarChart2, FiMenu, FiX, FiFolder,
  FiUsers, FiSettings, FiChevronDown, FiChevronRight,
  FiLayers
} from "react-icons/fi";
import { motion } from "framer-motion";

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const [isNomenclatureOpen, setIsNomenclatureOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  return (
    <motion.div
      initial={{ width: 64 }}
      animate={{ width: isSidebarOpen ? 240 : 64 }}
      transition={{ duration: 0.3 }}
      className="fixed top-16 left-0 h-screen bg-gradient-to-b from-gradientStart to-gradientEnd text-white transition-all shadow-lg flex flex-col overflow-y-auto hover:overflow-y-scroll pb-10"
      onMouseEnter={() => setIsSidebarOpen(true)}
      onMouseLeave={() => setIsSidebarOpen(false)}
    >
      {/* Bouton pour fixer/défixer le menu */}
      <div className="p-4 flex justify-between items-center">
        <button
          className="text-white hover:text-gray-300"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          {isSidebarOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>
      </div>

      {/* Menu principal */}
      <nav className="mt-5 flex flex-col space-y-4 w-full flex-grow">
        {/* Tableau de bord */}
        <Link
          to="/dashboard"
          className="flex items-center space-x-3 p-3 hover:bg-white hover:text-primary rounded-md transition"
        >
          <FiHome size={20} />
          {isSidebarOpen && <span>Tableau de bord</span>}
        </Link>

        {/* Projets */}
        <Link
          to="/projects"
          className="flex items-center space-x-3 p-3 hover:bg-white hover:text-primary rounded-md transition"
        >
          <FiFolder size={20} />
          {isSidebarOpen && <span>Projets</span>}
        </Link>

        {/* Évaluations */}
        <Link
          to="/evaluations"
          className="flex items-center space-x-3 p-3 hover:bg-white hover:text-primary rounded-md transition"
        >
          <FiBarChart2 size={20} />
          {isSidebarOpen && <span>Évaluations</span>}
        </Link>

        {/* Portefeuille */}
        <Link
          to="/portfolio"
          className="flex items-center space-x-3 p-3 hover:bg-white hover:text-primary rounded-md transition"
        >
          <FiLayers size={20} />
          {isSidebarOpen && <span>Portefeuille</span>}
        </Link>
        
        {/* Catalogue des effets */}
        <Link
          to="/CatalogEffects"
          className="flex items-center space-x-3 p-3 hover:bg-white hover:text-primary rounded-md transition"
        >
          <FiBarChart2 size={20} />
          {isSidebarOpen && <span>Catalogue des effets</span>}
        </Link>

       
          {/* ✅ Section Gestion des utilisateurs avec sous-menu */}
        <div className="mt-4">
          {isSidebarOpen && (
            <p className="px-3 text-sm font-semibold opacity-80">Administration générale</p>
          )}
          <button
            onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
            className="w-full flex items-center space-x-3 p-3 hover:bg-white hover:text-primary rounded-md transition"
          >
            <FiUsers size={20} />
            {isSidebarOpen && <span>Gestion des utilisateurs</span>}
            {isSidebarOpen &&
              (isUserMenuOpen ? (
                <FiChevronDown className="ml-auto" />
              ) : (
                <FiChevronRight className="ml-auto" />
              ))}
          </button>

          {/* Sous-menu */}
          {isUserMenuOpen && isSidebarOpen && (
            <div className="pl-6 mt-2 space-y-2">
              <Link
                to="/admin/users"
                className="flex items-center p-2 hover:bg-gray-700 rounded"
              >
                📋 Liste des utilisateurs
              </Link>
              {/* 🔧 Tu peux ajouter d’autres liens ici */}
              {/* <Link to="/admin/roles" className="flex items-center p-2 hover:bg-gray-700 rounded">⚙️ Gestion des rôles</Link> */}
            </div>
          )}
        </div>

        {/* ✅ Section Nomenclatures avec sous-menu */}
        <div className="mt-4">
          <button
            onClick={() => setIsNomenclatureOpen(!isNomenclatureOpen)}
            className="w-full flex items-center space-x-3 p-3 hover:bg-white hover:text-primary rounded-md transition"
          >
            <FiSettings size={20} />
            {isSidebarOpen && <span>Nomenclatures</span>}
            {isSidebarOpen && (isNomenclatureOpen ? <FiChevronDown className="ml-auto" /> : <FiChevronRight className="ml-auto" />)}
          </button>

          {/* Sous-menu des nomenclatures avec Scroll si nécessaire */}
          {isNomenclatureOpen && isSidebarOpen && (
            <div className="pl-6 mt-2 space-y-2">
              <Link to="/nomenclatures/sectors" className="flex items-center p-2 hover:bg-gray-700 rounded">
                📌 Secteurs
              </Link>
              <Link to="/nomenclatures/ministries" className="flex items-center p-2 hover:bg-gray-700 rounded">
                🏛 Ministères
              </Link>
              <Link to="/nomenclatures/intervention-types" className="flex items-center p-2 hover:bg-gray-700 rounded">
                ⚙️ Types d’intervention
              </Link>
              <Link to="/nomenclatures/structure-types" className="flex items-center p-2 hover:bg-gray-700 rounded">
                🏗 Types d’ouvrage
              </Link>
              <Link to="/nomenclatures/funding-types" className="flex items-center p-2 hover:bg-gray-700 rounded">
                💰 Types de financement
              </Link>
              <Link to="/nomenclatures/document-types" className="flex items-center p-2 hover:bg-gray-700 rounded">
                📄 Types de documents
              </Link>
              <Link to="/nomenclatures/regions" className="flex items-center p-2 hover:bg-gray-700 rounded">
                🌍 Régions
              </Link>
              <Link to="/nomenclatures/departments" className="flex items-center p-2 hover:bg-gray-700 rounded">
                🏢 Départements
              </Link>
              <Link to="/nomenclatures/communes" className="flex items-center p-2 hover:bg-gray-700 rounded">
                🏘 Communes
              </Link>
            </div>
          )}
        </div>
      </nav>
    </motion.div>
  );
};

export default Sidebar;
